import { useContext } from 'react'
import styled from 'styled-components'
import CreationToolSuperCutField from '../../../../../../types/super-cut-field'
import TitleField from '../../../../../form-fields/super-cut/capture-title'
import { CreationCaptureInfoContext } from '../manager'

const Title = styled(TitleField)`
    grid-column: span 2;
`

type Props = {
    field: CreationToolSuperCutField
}

const CreationCaptureInfoTitleField = ({ field }: Props) => {
    const { title, setTitle } = useContext(CreationCaptureInfoContext)

    return (
        <Title
            {...{
                field,
                title,
                onChange: setTitle,
            }}
        />
    )
}

export default CreationCaptureInfoTitleField
